import React from "react";

const CustomDropdown = ({
  label = "",
  name = "",
  value = "",
  options = [],
  onChange = () => {},
}) => {
  return (
    <div className="w-full h-fit flex flex-col space-y-2">
      <label
        htmlFor={name}
        className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor"
      >
        {label}
      </label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        className="w-full bg-whiteColor border-2 rounded-xl lg:rounded-2xl outline-primaryColor px-[4%] py-[3%] font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
      >
        <option value="" disabled>
          Select Relationship
        </option>
        {options.map((option, index) => (
          <option
            key={index}
            value={option.value}
            className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomDropdown;
